import React, { PropsWithChildren } from 'react'
import { ErrorBoundary } from 'react-error-boundary'
import '@veneer/styles/typography/typography.css'

import { mfePreset } from './mfe-preset'

import { UnrecoverableErrorPage } from '@/components/shared/UnrecoverableError'
import { useInitApp } from '@/hooks/useInitApp'
import { AppProps } from '@/types/app-props'
import { DependencyManagerProvider } from '@foreign-clientos/dependency-manager'

mfePreset()

export type CreateRootComponentOptions = {
  Wrapper?: React.FC<PropsWithChildren<unknown>>
}

const DefaultWrapper: NonNullable<CreateRootComponentOptions['Wrapper']> = ({
  children,
}) => <>{children}</>

export function createRootComponent(
  bundleName: string,
  EntryComponent: React.FC<AppProps>,
  options?: CreateRootComponentOptions,
) {
  const Wrapper = options?.Wrapper ?? DefaultWrapper

  return function RootComponent(props: AppProps) {
    const initialized = useInitApp(props, bundleName)

    return (
      initialized && (
        <Wrapper>
          <DependencyManagerProvider bundleName={bundleName}>
            <ErrorBoundary FallbackComponent={UnrecoverableErrorPage}>
              <EntryComponent {...props} />
            </ErrorBoundary>
          </DependencyManagerProvider>
        </Wrapper>
      )
    )
  }
}
